export const PAGE_CHANGE_MUTATION = 'PAGE_CHANGE_MUTATION';
export const SORT_UPDATE_MUTATION = 'SORT_UPDATE_MUTATION';
export const MAP_DRAWING_CHANGE_MUTATION = 'MAP_DRAWING_CHANGE_MUTATION';
export const UPDATE_LOADING_MUTATION = 'UPDATE_LOADING_MUTATION';
export const UPDATE_IS_MAP_LOADING = 'UPDATE_IS_MAP_LOADING';
export const UPDATE_SEARCH_PARAMS = 'UPDATE_SEARCH_PARAMS';
export const MAP_RESULT_UPDATE_MUTATION = 'MAP_RESULT_UPDATE_MUTATION';
export const GRID_OR_LIST_TYPE_MUTATION = 'GRID_OR_LIST_TYPE_MUTATION';
export const ACTIVE_HOUSE_MARKER_MUTATION = 'ACTIVE_HOUSE_MARKER_MUTATION';
export const REMOVE_ALL_FILTERS = 'REMOVE_ALL_FILTERS';
export const SET_SORT_CONFIGS = 'SET_SORT_CONFIGS';
export const SET_MAP_INITED = 'SET_MAP_INITED';
export const REMOVE_OUTLINE_REGION = 'REMOVE_OUTLINE_REGION';
export const MARKET_REPORT_DISPATCH = 'MARKET_REPORT_DISPATCH';
export const SET_MARKET_REPORT_DATA = 'SET_MARKET_REPORT_DATA';
export const PREV_VIEW_PATTERN_MUTATION = 'PREV_VIEW_PATTERN_MUTATION';
export const AVERAGE_DATA_MUTATION = 'AVERAGE_DATA_MUTATION';
export const SHOW_INSIGHT_UPDATE_MUTATION = 'SHOW_INSIGHT_UPDATE_MUTATION';

export const SET_CENTER_POINT = 'SET_CENTER_POINT';
export const SET_ZOOM = 'SET_ZOOM';
export const PROPERTY_GATHERING_AMOUNT = 'PROPERTY_GATHERING_AMOUNT';

export const SET_BREAD_CRUMBS = 'SET_BREAD_CRUMBS';

// ?????????
export const UPDATE_URL = 'UPDATE_URL';
export const UPDATE_CONDITION = 'UPDATE_CONDITION';
export const CENTER_DEL_CONDITION = 'CENTER_DEL_CONDITION';
export const CENTER_DEL_KEYWORD = 'CENTER_DEL_KEYWORD';
export const CENTER_DEL_INPUT_BOX = 'CENTER_DEL_INPUT_BOX';
export const SET_TRANSLATED_PROPS = 'SET_TRANSLATED_PROPS';
export const CENTER_DEL_SUGGESTION = 'CENTER_DEL_SUGGESTION';

export const REMOVE_KEYWORD_MUTATION = 'REMOVE_KEYWORD_MUTATION';
export const MAP_CHANGE_MUTATION = 'MAP_CHANGE_MUTATION';
export const LAYOUT_UPDATE_MUTATION = 'LAYOUT_UPDATE_MUTATION';
export const QUICK_SEARCH_STATE_MUTATION = 'QUICK_SEARCH_STATE_MUTATION';
export const SEARCH_DATA_ACTION = 'SEARCH_DATA_ACTION';
